import React, { useState } from "react";
import { FaLock, FaMinus, FaPlus, FaFileMedical, FaShieldAlt, FaUserCheck,  FaLaptopMedical, FaBrain, FaHeartbeat, FaHospital, FaMoneyBillWave,FaMobileAlt, FaDiagnoses, FaRobot, FaVideo, FaDna } from "react-icons/fa";


import Medpalm from "../../../assests/Healthcaretechnology/Digital.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
import {  } from "react-icons/fa";
import { IoWatch } from "react-icons/io5";

const services = [
    {
        title: "Telemedicine Platforms",
        description:
          "Telemedicine platforms provide patients with remote access to healthcare services, enabling virtual consultations with doctors through video calls, chat, or phone. These platforms integrate AI-powered chatbots to assist with symptom checking, scheduling, and answering medical queries. Additionally, they offer e-prescriptions, allowing healthcare providers to electronically prescribe medications, improving patient convenience and reducing the need for in-person visits."
      },
      {
        title: "Healthcare Analytics",
        description:
          "Healthcare analytics solutions leverage big data and artificial intelligence to analyze patient records, treatment outcomes, and operational workflows. Predictive analytics helps identify disease trends and patient risks, allowing for early intervention. Population health management tools provide insights into community health, enabling targeted strategies to improve healthcare outcomes. These solutions also enhance hospital efficiency by optimizing resource allocation, reducing costs, and improving patient care coordination."
      },
      {
        title: "Hospital Management Software",
        description:
          "Hospital management software streamlines administrative and clinical workflows by integrating electronic medical records (EMR), appointment scheduling, billing automation, and inventory management. These platforms help healthcare facilities manage patient data securely, comply with regulatory standards, and reduce paperwork. Features such as AI-driven workflow optimization and automated documentation improve efficiency, enhance patient experiences, and reduce operational overhead."
      },
      {
        title: "AI-Powered Diagnostics",
        description:
          "AI-powered diagnostic systems use machine learning algorithms to assist in disease detection and medical imaging analysis. These tools analyze radiology scans, pathology slides, and genetic data to identify abnormalities and provide early warnings for conditions like cancer, cardiovascular diseases, and neurological disorders. AI-driven diagnostic support systems help clinicians make faster, more accurate decisions, reducing diagnostic errors and improving treatment outcomes."
      },
      {
        title: "Remote Patient Monitoring",
        description:
          "Remote patient monitoring (RPM) utilizes IoT-enabled wearable devices, mobile apps, and cloud-based platforms to continuously track patients' health conditions outside of clinical settings. RPM systems monitor vital signs such as heart rate, blood pressure, oxygen levels, and glucose levels, transmitting real-time data to healthcare providers. These solutions enhance chronic disease management, reduce hospital readmissions, and allow for timely medical interventions without requiring frequent hospital visits."
      },
      {
        title: "Drug Discovery & Research",
        description:
          "AI-driven drug discovery platforms accelerate pharmaceutical research by analyzing molecular structures, predicting drug interactions, and optimizing clinical trial management. These solutions utilize computational models to identify potential drug candidates faster than traditional methods, reducing the time and cost of bringing new medications to market. Advanced analytics also aid in personalized medicine by tailoring treatments based on genetic and biomarker data, improving therapeutic efficacy."
      }
    ];
const features = [
    { icon: <FaRobot className="text-[#2a627a] text-lg" />, text: "AI & Machine Learning – AI-driven diagnostics, predictive analytics, and automated health recommendations." },
    { icon: <FaVideo className="text-[#2a627a] text-lg" />, text: "Telemedicine Solutions – Virtual doctor consultations, remote patient monitoring, and e-prescriptions." },
        { icon: <IoWatch className="text-[#2a627a] text-lg" />, text: "Wearable Health Tech – Smartwatches, fitness trackers, and biosensors to monitor health metrics in real time." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Electronic Health Records (EHRs) – Cloud-based health record management for seamless patient data access." },
    { icon: <FaDna className="text-[#2a627a] text-lg" />, text: "Personalized Medicine – Genomic data analysis for customized treatments and disease predictions." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Cybersecurity & Data Protection – HIPAA-compliant encryption, blockchain solutions, and secure cloud storage." }
  ];
const benefits = [
    { icon: <FaUserCheck className="text-[#2a627a] text-lg" />, text: "Better Access to Healthcare – Telemedicine and remote monitoring allow patients to consult doctors anytime, anywhere." },
  { icon: <FaMoneyBillWave className="text-[#2a627a] text-lg" />, text: "Cost Reduction – Automated systems and AI reduce administrative costs and improve efficiency." },
  { icon: <FaDiagnoses className="text-[#2a627a] text-lg" />, text: "Faster Diagnosis & Treatment – AI-driven analytics can identify diseases early and suggest appropriate treatments." },
  { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Personalized Patient Care – Wearable health devices and personalized medicine improve treatment outcomes." },
  { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "Enhanced Data Security – Blockchain and encryption technologies safeguard patient information." }
];
const consentItems = [
    { icon: <FaMobileAlt className="text-[#2a627a] text-lg" />, text: "Enhancing Patient Engagement – Offering mobile apps for real-time health tracking, medication reminders, and virtual consultations." },
  { icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />, text: "Improving Healthcare Access – Enabling remote patient monitoring and telehealth services for underserved populations." },
  { icon: <FaBrain className="text-[#2a627a] text-lg" />, text: "Data-Driven Decision Making – Utilizing AI and big data for early disease detection and personalized treatment." },
  { icon: <FaHospital className="text-[#2a627a] text-lg" />, text: "Optimizing Hospital Operations – Developing digital solutions to improve patient flow, reduce wait times, and enhance staff efficiency." },
  { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Ensuring Secure Health Data – Implementing blockchain and cybersecurity solutions to protect sensitive medical records." }
];
const Digitalhealth = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 ">Digital Health Startup  </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                    "Driving innovation in healthcare through technology, enhancing accessibility, efficiency, and patient outcomes.".
                    </p>
                </div>

                {/* What is Consent? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-2xl hover:shadow-2xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is a Digital Health Startup?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        A digital health startup is a company that leverages technology to improve healthcare delivery, patient outcomes, and overall efficiency in the medical industry. These startups focus on innovations such as telemedicine, wearable devices, AI-driven diagnostics, mobile health apps, and electronic health records (EHRs) to enhance patient care and streamline medical processes.
                        </p>
                    </div>
                </section>

                {/* Role of Patient Flow Management*/}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 ">
                        Role of Digital Health Startup
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {consentItems.map((item, index) => (
                            <motion.div
                                key={index}
                                className="relative z-10 bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl"
                                initial={{ opacity: 0, x: -100 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1 }}
                            >
                                <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 ">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="relative bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl flex flex-col items-center text-center"
                                initial={{ opacity: 0, x: 20 }}
                                whileInView={{ opacity: 1, x: -10 }}
                                transition={{ duration: 1 }}
                            // viewport={{ once: true }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium mt-3">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-bg-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-bg-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default Digitalhealth;
